import { inject, Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot
} from '@angular/router';
import { SubscriptionManagementService } from '@App/pages/pricing/services/subscription-management.service';
import { map, take } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
class SubscriptionValidation {
  constructor(
    private subscriptionManagementService: SubscriptionManagementService,
    private router: Router
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.subscriptionManagementService.getCurrentPlan().pipe(
      take(1),
      map((plan) => {
        if (!plan) {
          this.router.navigate(['/pricing']).then();
          return false;
        }

        return true;
      })
    );
  }
}

export const SubscriptionValidationGuard: CanActivateFn = (
  next: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  return inject(SubscriptionValidation).canActivate(next, state);
};
